import { type GetHookResponse } from '../hooks'
import { featureHistoryKey } from '../keys'
import { useTantalimQuery } from '../query'
import { type FeatureHistoryInput, type FeatureHistorySuccess } from '@terros/common'

export function useFeatureHistory(input: FeatureHistoryInput): GetHookResponse<FeatureHistorySuccess> {
  return useTantalimQuery<FeatureHistoryInput, FeatureHistorySuccess, FeatureHistorySuccess>({
    url: '/feature/history',
    queryKey: featureHistoryKey(input),
    input,
    convertResponse: (data) => data,
  })
}
